'use client'

import { createContext, ReactNode, useContext, useState } from 'react'

interface FilterChangeContextType {
  lastFilterChange: Date | null
  setLastFilterChange: (date: Date | null) => void
}

const FilterChangeContext = createContext<FilterChangeContextType | undefined>(
  undefined
)

export const useFilterChange = () => {
  const context = useContext(FilterChangeContext)

  if (!context) {
    throw new Error(
      'useFilterLoading must be used within a FilterLoadingProvider'
    )
  }

  return context
}

interface FilterChangeProviderProps {
  children: ReactNode
}

export const FilterChangeProvider = ({
  children
}: FilterChangeProviderProps) => {
  const [lastFilterChange, setLastFilterChange] = useState<Date | null>(null)

  return (
    <FilterChangeContext.Provider
      value={{
        lastFilterChange,
        setLastFilterChange
      }}
    >
      {children}
    </FilterChangeContext.Provider>
  )
}
